<template>
    <div class="p-t-xs-20 p-b-xs-20">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Validatie resultaat') }}
                            </div>
                        </div>
                        <table class="ak-table ak-table--compact ak-panel__table">
                            <thead>
                                <tr class="ak-table-row">
                                    <th class="ak-table-head">
                                        {{ $t('Barcode') }}
                                    </th>
                                    <th class="ak-table-head">
                                        {{ $t('Pincode') }}
                                    </th>
                                    <th class="ak-table-head">
                                        {{ $t('Status') }}
                                    </th>
                                    <th class="ak-table-head">
                                        {{ $t('Foutmelding') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="ak-table-body">
                                <tr
                                    v-for="item in output.items"
                                    :key="item.barcode"
                                    class="ak-table-row"
                                    :class="{'tr-danger' : !item.isValid}"
                                >
                                    <td class="ak-table-column">
                                        {{ item.barcode }}
                                    </td>
                                    <td class="ak-table-column">
                                        {{ item.pincode }}
                                    </td>
                                    <td class="ak-table-column">
                                        {{ item.isValid ? $t('Ok') : $t('Fout') }}
                                    </td>
                                    <td class="ak-table-column" v-html="item.errorForDisplay">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <ak-button
                        v-if="!output.hasInvalid"
                        @click="submit"
                    >
                        {{ $t('Importeren') }}
                    </ak-button>

                    <ak-button
                        @click="cancel"
                        :enableConfirm="true"
                        :confirmTitle="$t('Ben je zeker?')"
                        :confirmText="$t('Ben je zeker dat je wil annuleren?')"
                    >
                        {{ $t('Annuleren') }}
                    </ak-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BarcodeValidation',
    data() {
        return {
            barcodeImport: null,
            output: null,
            loading: false,
        };
    },
    methods: {
        async initialize() {
            this.loading = true;
            const result = await this.$get('/barcodes/validate/' + this.$route.params.hashId);
            if (result.success) {
                this.barcodeImport = result.data.barcodeImport;
                this.output = result.data.output;
            }

            this.loading = false;
        },
        async submit () {
            this.loading = true;
            const result = await this.$get('/barcodes/confirm/' + this.$route.params.hashId);
            this.loading = false;

            if (result.success) {
                this.redirectToGrid();
            }
        },
        async cancel () {
            this.loading = true;
            const result = await this.$get('/barcodes/decline/' + this.$route.params.hashId);
            this.loading = false;

            if (result.success) {
                this.redirectToGrid();
            }
        },
        redirectToGrid () {
            this.$router.push({name: 'grid', params:{bundle: 'barcode-import', gridDefinition: 'grid'}});
        }
    },
    created() {
        this.initialize();
    }
};
</script>
